<span class="{{ avatarStyle[examStatus()].classColor }}">
  <span matTooltip="{{ avatarStyle[examStatus()].title }}" matChipAvatar class="material-symbols-outlined">
    {{ avatarStyle[examStatus()].icon }}
  </span>
</span>
